<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 08:26:47
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-04-24 10:49:47
-->
<template>
  <div id="top-header">
    <div class="center-title">广水市校园餐供应链数字平台大数据中心</div>
    <router-link to="/agriculture" class="home">
      <img src="@/img/datav-tc/home_icon.png" alt="" />
    </router-link>
    <div class="clock">
      <div class="weather">
        天气<span>{{ weather }}</span>
      </div>
      <div class="date">
        <span>{{ date }}</span>
        <span class="week">{{ week }}</span>
      </div>
      <div class="time">{{ time }}</div>
    </div>
    <div class="sysInfo">
      <div class="day">
        平台安全运行
        <span>{{ xycDays }}天</span>
      </div>
      <div class="status">
        状态<span>{{ safeStatus }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { plaformInfo } from '@/api/dashboard-tc'
import to from 'await-to'
export default {
  name: 'TopHeader',
  data() {
    return {
      date: '',
      time: '',
      week: '',
      weather: '',
      xycDays: '',
      safeStatus: '',
    }
  },
  mounted() {
    this.currentTime()
    this.getWeather()
    setInterval(() => {
      this.getWeather()
    }, process.env.VUE_APP_LTIME_TC)
  },
  // 销毁定时器
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
  methods: {
    currentTime() {
      setInterval(this.formatDate, 500)
    },
    formatDate() {
      let date = new Date()
      let year = date.getFullYear() // 年
      let month = date.getMonth() + 1 // 月
      let day = date.getDate() // 日
      let week = date.getDay() // 星期
      let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      let hour = date.getHours() // 时
      // hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
      let minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零
      // let second = date.getSeconds() // 秒
      // second = second < 10 ? '0' + second : second // 如果只有一位，则前面补零
      this.date = `${year}-${month}-${day}`
      // this.time = `${hour}:${minute}:${second}`
      this.time = `${hour}:${minute}`
      this.week = `${weekArr[week]}`
    },
    async getWeather() {
      const [res, err] = await to(plaformInfo())
      if (err) return
      this.xycDays = res.data.xycDays
      this.weather = res.data.weather
      this.safeStatus = res.data.safeStatus
    },
  },
}
</script>

<style lang="scss">
#top-header {
  position: relative;
  width: 100%;
  height: 161px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  background: url('~@/img/datav-tc/top_bg.png');
  background-size: 100%;

  .dv-decoration-3 {
    position: absolute;
    top: 0;
    width: 800px;
    height: 90px;

    &.left {
      left: -565px;
    }

    &.right {
      right: -565px;
    }
  }

  .center-title {
    position: absolute;
    left: 50%;
    top: 44px;
    line-height: 65px;
    transform: translateX(-50%);
    font-size: 65px;
    text-align: center;
    color: #ffffff;
    font-weight: 700;
  }

  .home {
    cursor: pointer;
    position: absolute;
    left: 340px;
    top: 102px;
    display: flex;
    align-items: center;

    img {
      width: 73px;
      height: 73px;
    }
  }

  .clock,
  .sysInfo {
    position: absolute;
    top: 102px;
  }

  .clock {
    left: 502px;
    display: flex;
    align-items: center;

    .weather {
      font-size: 32px;
      color: rgba(255, 255, 255, 0.7);
      margin-right: 56px;

      span {
        color: #66ffff;
        margin-left: 26px;
      }
    }

    .time {
      font-size: 48px;
      color: #66ffff;
    }

    .date {
      font-size: 32px;
      color: rgba(255, 255, 255, 0.7);
      margin-right: 64px;

      span {
        margin-right: 10px;
      }
    }
  }

  .sysInfo {
    left: 3152px;
    display: flex;
    align-items: center;

    .day {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: rgba(255, 255, 255, 0.7);
      margin-right: 103px;

      span {
        font-size: 48px;
        color: #66ffff;
        margin-left: 27px;
      }
    }

    .status {
      font-size: 30px;
      color: #ffffff;

      span {
        color: #66ffff;
        margin-left: 27px;
      }
    }
  }
}
</style>
